import React, { useEffect } from "react";
import { useState } from "react";
import "./styles/Auth.css"
import { useNavigate } from "react-router";
import API_BASE_URL from "../config";

function Register() {

    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("");

    const [errorMsg, setErrorMsg] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);

        const URL = `/api/gallery/profiles/register`

        const data = JSON.stringify({username:username, email:email, password:password})
        
        try{
        
            const response = await fetch(URL, {
                method: "POST",
                headers: {
                    "Content-Type":"application/json"
                },
                body: data
            });

            const responseData = await response.json();

            if(responseData.error){
                setErrorMsg(responseData.error);
                setIsLoading(false);
                return;
            }

            navigate("/login");

            
            console.log(responseData);
        } catch(error){
            console.error(error);
        }

        setIsLoading(false);

    }

    return(
        <div>
            <form onSubmit={handleSubmit} className="auth-form" >

                <div className="auth-header">
                    <h1>Register</h1>
                </div>

                <text>Username</text>
                <input placeholder="Enter Username" onChange={(e) => {setUsername(e.target.value)}} disabled={isLoading}/>

                <text>Email</text>
                <input placeholder="Enter Email" onChange={(e) => {setEmail(e.target.value)}} disabled={isLoading}/>
        
                <text>Password</text>
                <input placeholder="Enter Password" onChange={(e) => {setPassword(e.target.value)}} disabled={isLoading}/>

                {errorMsg ? <text style={{color:"red"}}>{errorMsg}</text>:null}
                <button type="submit" disabled={isLoading}>register</button>
            

                <div className="auth-switch">
                    <text>Have an account?</text>
                    <a style={{color:"teal", margin:"auto", cursor:"pointer"}} onClick={() => navigate("/login")}>Login Here</a>
                </div>
            </form>
        </div>
    )
    
}

export default Register;